import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {AmenitiesService} from '../../../services/amenities.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {ApiClientService} from '../../../services/api-client.service';
import {MaintenanceCalendarService} from '../../../services/maintenance-calendar.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'maintenance-calendar-list',
    templateUrl: './maintenance-calendar-list.component.html',
    styleUrls: ['./maintenance-calendar-list.component.scss']
})
export class MaintenanceCalendarListComponent {

    constructor(
        public urlService: UrlService,
        public api: ApiClientService,
        public maintenanceCalendarService: MaintenanceCalendarService,
        public authenticationService: AuthenticationService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.maintenanceCalendarService.data.allAmenities.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    editAmenity(incident) {
        this.maintenanceCalendarService.editAmenity(incident);
    }

    showPaymentModal(booking) {
        this.maintenanceCalendarService.showPaymentModal(booking);
    }
    showDepositChargeModal(booking) {
        this.maintenanceCalendarService.showDepositChargeModal(booking);
    }

    deleteAmenity(incident) {
        this.maintenanceCalendarService.deleteAmenity(incident.id);
        incident.showDropdown = false;
    }

    viewAmenity(amenity): void {
        this.maintenanceCalendarService.amenityInAmenityModal = amenity;
        this.maintenanceCalendarService.isAmenityViewShow = true;
    }

    approveBooking(item): void {
        if(this.allPaymentArePaid(item)) {
            let transitionStatus = '';
            if (item.status == 'pending')
                transitionStatus = 'approved';
            else if (item.status == 'declined')
                transitionStatus = 'declined_approved';
            const url = `/v1/booking/transit/${item.id}.json`;
            this.maintenanceCalendarService.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
                () => this.updateView('Status was successfully updated'),
                error => this.api.errorHandler(error, 'Status update failed!')
            );
        } else
            toastr.warning('All payments must be paid before you can confirm the booking.');
    }

    declineBooking(item): void {
        let transitionStatus = '';
        if(item.status == 'pending')
            transitionStatus = 'declined';
        else if(item.status == 'approved')
            transitionStatus = 'approved_declined';
        const url = `/v1/booking/transit/${item.id}.json`;
        this.maintenanceCalendarService.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
            () => this.updateView('Status was successfully updated'),
            error => this.api.errorHandler(error, 'Status update failed!')
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.maintenanceCalendarService.getData();
    }

    allPaymentArePaid(item): boolean {
        let allPaid = true;
        if(item.payments && item.payments.length > 0) {
            item.payments.filter((payment) => {
                if(payment.chosen && !payment.status)
                    allPaid = false;
            });
        }
        return allPaid;
    }

    bookingHasPayments(item): boolean {
        let allPaid = true;
        if(!item.payments || item.payments.length < 1)
            allPaid = false;
        return allPaid;
    }

    bookingHasPaidPayments(item): boolean {
        let hasPaid = false;
        if(item.payments && item.payments.length > 0) {
            item.payments.forEach(payment => {
                if(payment.status)
                    hasPaid = true;
            });
        }
        return hasPaid;
    }

    isBookingDateLaterThanCurrent(item): boolean {
        let flag = false;
        if(new Date(item.dateTo) <= new Date())
            flag = true;
        return flag;
    }

    firstButton(item) {
        if(item.isCanEdit && item.status == 'declined')
            return 'edit';
        else if(item.isCanApprove && item.status == 'pending' && this.allPaymentArePaid(item))
            return 'approve';
        else if(item.isCanEdit && item.status == 'pending' && !this.allPaymentArePaid(item))
            return 'pay';
        else
            return 'view';
        // else if(this.isBookingDateLaterThanCurrent(item) || item.status == 'approved')
        //     return 'view';
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-list/maintenance-calendar-list.component.ts